import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const withTenant = (Component) => {

    const Wrapper =  (props)=>{ 
        console.log('withTenant: => Starting');
        const navigate = useNavigate();
        const pathname = window.location.pathname;
        const usernameTenant  = pathname.split('/')[1];
        const [isTenant,setIsTenant] = useState(false);
        useEffect(()=>{
            let isActive = true;
            const getTenant = async() => {
                try{
                    const res = await axios.get(`${process.env.REACT_APP_Auth_API_BASE_URL}/tenants/username/${usernameTenant}`);
                    const _data = res?.data?.data;
                    if(!isActive) return;
                    if(_data){
                        localStorage.setItem('tenant',JSON.stringify( _data));
                        setIsTenant(true);
                        return;
                    }
                }catch(err){
                    if(!isActive) return;
                }
                const cachedTenantRaw = localStorage.getItem('tenant');
                let cachedTenant = null;
                try {
                    cachedTenant = cachedTenantRaw ? JSON.parse(cachedTenantRaw) : null;
                } catch {
                    cachedTenant = null;
                }
                if(cachedTenant && cachedTenant?.username === usernameTenant){
                    setIsTenant(true);
                    return;
                }
                navigate('/notfound');
            }
            getTenant();
            return () => {
                isActive = false;
            }
        },[navigate, usernameTenant]);

        if(isTenant){
            console.log('withTenant: => is Ready');
            return   <Component {...props} /> 
        }
        

    }
    return Wrapper;
}

export default withTenant
